import { inject, observer } from "mobx-react";
import React from "react";
import { FormGroup, Menu, withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import FileCopy from "@material-ui/icons/FileCopy";
import PlayArrow from "@material-ui/icons/PlayArrow";
import BurstModeIcon from "@material-ui/icons/BurstMode";
import SaveAlt from "@material-ui/icons/SaveAlt";
import { download } from "../utils/downloadUtil";
import CircularProgress from "@material-ui/core/CircularProgress";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { CloudUpload } from "@material-ui/icons";

const MenuButton = withStyles({
  root: {
    justifyContent: "left",
    width: "100%"
  }
})(Button);

class ClipActions extends React.Component {
  state = {
    anchorEl: null,
    loading: false
  };

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      item,
      reelStore,
      videoPlayerStore,
      sendToForgeDialogStore,
      authStore
    } = this.props;

    const { anchorEl } = this.state;

    return (
      <React.Fragment>
        <IconButton
          aria-label="More"
          aria-owns={anchorEl ? "long-menu" : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          style={{ padding: "6px" }}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          <FormGroup style={{ padding: "6px" }}>
            {authStore.canSendToForge && (
              <MenuButton
                variant={"text"}
                onClick={() => {
                  sendToForgeDialogStore.openDialog(item.videoId);
                }}
                disabled={sendToForgeDialogStore.isLoading(item.videoId)}
              >
                {sendToForgeDialogStore.isLoading(item.videoId) ? (
                  <CircularProgress size={25} />
                ) : (
                  <React.Fragment>
                    <CloudUpload style={{ marginRight: "10px" }} /> Send To
                    Forge
                  </React.Fragment>
                )}
              </MenuButton>
            )}
            <MenuButton
              variant={"text"}
              onClick={() => {
                reelStore.restoreReel(item.videoId);
              }}
            >
              <BurstModeIcon style={{ marginRight: "10px" }} /> Recut Reel
            </MenuButton>
            <MenuButton
              variant={"text"}
              onClick={() => navigator.clipboard.writeText(item.url)}
            >
              <FileCopy style={{ marginRight: "10px" }} /> Copy Link
            </MenuButton>
            <MenuButton
              variant={"text"}
              onClick={() => {
                videoPlayerStore.showVideoSrc(item.url);
              }}
            >
              <PlayArrow style={{ marginRight: "10px" }} /> Watch
            </MenuButton>
            {authStore.canDownloadVideos && (
              <MenuButton
                variant={"text"}
                onClick={() => {
                  download(item.url, item.name);
                }}
              >
                <SaveAlt style={{ marginRight: "10px" }} /> Download
              </MenuButton>
            )}
          </FormGroup>
        </Menu>
      </React.Fragment>
    );
  }
}

export default inject(
  "reelStore",
  "videoPlayerStore",
  "sendToForgeDialogStore",
  "authStore"
)(observer(ClipActions));



// WEBPACK FOOTER //
// ./src/components/ClipActions.js